/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function CheckThickIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M34.063 14.087h.124l-16 15.977c-1.25 1.248-3.125 1.248-4.25 0l-8-7.989c-1.25-1.123-1.25-2.996 0-4.119 1.125-1.248 3-1.248 4.25 0l5.876 5.867 13.875-13.98c1.125-1.124 3-1.124 4.125 0 1.25 1.248 1.25 3.12 0 4.243"/>}
        </IconWrapper>);
}
